import React from 'react';
import { Outlet } from 'react-router';
import { PrivateRoute } from '../../components/PrivateRoute';
import { Row, Col } from 'antd';
// import Breadcrumbs from "../../components/UI/Breadcrumb";

export default function AdminLayout() {
  return (
    <PrivateRoute permission={['ADMIN']}>
      <div
        style={{
          display: 'block',
          width: '100%',
          padding: '2em',
          textAlign: 'left',
        }}>
        <Row gutter={[16, 16]} style={{ height: '100%', width: '100%', margin: 0 }}>
          {/* <Col span={24}>
            <Breadcrumbs/>
          </Col> */}
          <Col span={24}>
            <Outlet />
          </Col>
        </Row>
      </div>
    </PrivateRoute>
  );
}
